import React from "react";
import {Layout, Menu, Breadcrumb, Row, Col, Avatar} from "antd";
import {
  UserOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import "../../styles/DashboardLayout.less";
import {useAuth} from "../../hooks";
import {NavLink, useLocation} from "react-router-dom";
import {dashboardRoutes} from "../../routers";
import {useHistory} from "react-router-dom";

const {Header, Content, Footer, Sider} = Layout;
const {SubMenu} = Menu;

const rootSubmenuKeys = [""];

const DashboardLayout = ({children: PanelContent}) => {
  const [collapsed, setCollapsed] = React.useState(false);
  const [openKeys, setOpenKeys] = React.useState([""]);
  const [selectedKey, setSelectedKey] = React.useState("");
  const location = useLocation();
  const {user, userData, userLoading, signOut} = useAuth();
  const history = useHistory();
  const [rutas, setRutas] = React.useState([]);
  const [_lsUserData, set_lsUserData] = React.useState(JSON.parse(localStorage.getItem('usuario')));
  const [_lsUserChane, set_lsUserChane] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => {
      set_lsUserChane(!_lsUserChane);
      set_lsUserData(JSON.parse(localStorage.getItem('usuario')))
    }, 100);
  }, [_lsUserChane])


  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      let _rutas = [];
      if (userData[0].rol === 'usuario') {
        const valuesToRemove = [
          'Videos',
          'Usuarios',
          'Visitas',
          'Agregar video']
        _rutas = dashboardRoutes.filter(item => !valuesToRemove.includes(item.name))
      } else {
        const valuesToAdd = [
          'Inicio',
          'Video',
          'Usuarios',
          'Mi cuenta',
          'Videos',
          'Agregar video',
          'XXI Simposio',
          'XXII Simposio',
          'XXIII Simposio',
          'Reconocimiento',
          'Editar video',
          'Visitas'
        ];
        _rutas = dashboardRoutes.filter(item => valuesToAdd.includes(item.name))
      }
      console.log(userData[0])
      setRutas(_rutas)
    }
    return () => mounted = false;
  }, [userData])

  React.useEffect(() => {
    let mounted = true;
    if (mounted) setCollapsed(false);
    return () => mounted = false;
  }, [])

  React.useEffect(() => {
    const flatter = (r) =>
      r?.routes
        ? [
          r,
          ...r?.routes
            .map((sub) => ({...sub, path: r.path + sub.path}))
            .flatMap(flatter),
        ]
        : r;
    const flatted = dashboardRoutes.flatMap(flatter);
    const paths = flatted.map((r) => r.path);
    const key = paths.find((path) => path === location.pathname);

    setSelectedKey(key);
    const tmpOpenKeys = flatted
      .filter(
        (r) => r.sidebar === "collapse" && location.pathname.includes(r.path)
      )
      .map((r) => "collapse-" + r.path);
    setOpenKeys(tmpOpenKeys);
  }, [location]);

  const onCollapse = () => {
    setCollapsed(c => !c);
  };

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const sidebarMapper = (route) => {

    if (route.sidebar === "single") {
      return (
        <Menu.Item
          key={route.path}
          onClick={() => setSelectedKey(route.path)}
          icon={route.icon}
        >
          <NavLink to={route.path}>{route.name}</NavLink>
        </Menu.Item>
      );
    } else if (route.sidebar === "collapse") {
      const innerMap = (r) => ({...r, path: route.path + r.path});
      const finalKey = "collapse-" + route.path;
      return (
        <SubMenu key={finalKey} icon={route.icon} title={route.name}>
          {route?.routes?.map(innerMap).map(sidebarMapper)}
        </SubMenu>
      );
    }
    return null;
  };

  if (!user && userLoading) return null;


  return (
    <Layout style={{minHeight: "100vh"}}>
      <Sider
        id="auth-sider"
        collapsible
        collapsed={collapsed}
        onCollapse={onCollapse}
        theme="light"
      >
        <img src={"/logoXXIV.png"} width="100%" alt="Logo"/>
        <Menu
          mode="inline"
          openKeys={collapsed ? false : openKeys}
          onOpenChange={onOpenChange}
          className="sider-menu"
          defaultSelectedKeys={selectedKey}
          inlineIndent={18}
        >
          {rutas.map(sidebarMapper)}
          <Menu.Item
            key="single-/0"
            icon={<LogoutOutlined/>}
            onClick={signOut}
          >
            Cerrar sesión
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout className="site-layout">
        <Header
          className="site-layout-background"
          style={{padding: "0px 10px"}}
        >
          <Row justify="space-between">
            <Col>
            </Col>
            <Col>
              <Row onClick={() => history.push('/cuenta')}>
                <Col className="username">{_lsUserData.nombre + ' ' + _lsUserData.apellidos} </Col>
                <Col style={{marginLeft: 10}}>
                  <Avatar
                    size={42}
                    icon={<UserOutlined/>}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Header>
        <Content style={{margin: "0 16px"}}>
          <Breadcrumb style={{margin: "16px 0"}}>
            <Breadcrumb.Item></Breadcrumb.Item>
          </Breadcrumb>
          <div className="site-layout-background" style={{padding: 24}}>
            {PanelContent}
          </div>
        </Content>
        <Footer style={{textAlign: "center"}}>
          Derechos reservados Simposio Nogal {new Date().getFullYear()} &#xa9;
        </Footer>
      </Layout>
    </Layout>
  );
};

export default DashboardLayout;
